import { Mail, MessageSquare } from "lucide-react";
import SEOHead from "@/components/SEOHead";

const ContactPage = () => {
  return (
    <>
      <SEOHead
        title="Contact Us | SwissFlow PDF"
        description="Contact SwissFlow PDF for support, feedback, or inquiries. Email us at twopearlsprivatelimited@gmail.com. We respond within 24-48 hours."
        canonicalPath="/contact"
        keywords="contact SwissFlow PDF, PDF tools support, help"
      />
      <div className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-12 animate-fade-in-up">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-[#FF3B30] flex items-center justify-center">
                <MessageSquare className="w-7 h-7 text-white" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold font-['Outfit'] tracking-tight">
                Contact Us
              </h1>
            </div>
            <p className="text-lg text-muted-foreground max-w-2xl">
              Have questions, feedback, or need support? We'd love to hear from you.
            </p>
          </div>

          {/* Contact Info */}
          <div className="max-w-xl mx-auto animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
            <div className="bg-card border border-border p-8 text-center">
              <div className="w-16 h-16 bg-[#FF3B30]/10 flex items-center justify-center mx-auto mb-6">
                <Mail className="w-8 h-8 text-[#FF3B30]" />
              </div>
              <h2 className="text-2xl font-bold font-['Outfit'] mb-4">Email Us</h2>
              <a 
                href="mailto:twopearlsprivatelimited@gmail.com" 
                className="text-xl text-[#FF3B30] hover:underline font-medium"
                data-testid="contact-email"
              >
                twopearlsprivatelimited@gmail.com
              </a>
              <p className="text-muted-foreground mt-4 text-sm">
                We typically respond within 24-48 hours during business days.
              </p>
            </div>

            <div className="mt-8 bg-card border border-border p-6">
              <h3 className="font-semibold font-['Outfit'] mb-4">What We Can Help With</h3>
              <ul className="text-sm text-muted-foreground space-y-2">
                <li>• Technical support and troubleshooting</li>
                <li>• Feature requests and suggestions</li>
                <li>• Bug reports</li>
                <li>• General inquiries</li>
                <li>• Business partnerships</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
